module.exports = __webpack_public_path__ + "static/media/trees.423e4268.png";